import { Button, XStack, XStackProps } from '@my/ui'
import { FilterListProps, FilterOption } from './group-filter'

export interface FilterListItemProps extends Omit<FilterListProps, 'filters'> {
  item: FilterOption
}

export const FilterListItem = ({
  item,
  onFilterChange,
  activeFilters,
  ...props
}: FilterListItemProps & XStackProps) => {
  const isActive = activeFilters.some((filter) => filter.value === item.value)
  return (
    <XStack width="auto" {...props}>
      <Button
        theme={isActive ? 'primary' : 'gray'}
        mr="$2"
        onPress={() => onFilterChange(item)}
        size="$2"
        focusStyle={{
          outlineWidth: 0,
        }}
        $gtSm={{
          size: '$3',
        }}
        fontWeight="500"
      >
        {item.label}
      </Button>
    </XStack>
  )
}
